export const C = {
  bg: '#0B0F14',
  surface: '#111827',
  surfaceHover: '#1a2233',
  border: '#1F2937',
  borderHover: '#374151',
  primary: '#F59E0B',
  primaryHover: '#FBBF24',
  secondary: '#3B82F6',
  secondaryHover: '#60A5FA',
  highlight: '#22D3EE',
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6',
  text: '#E5E7EB',
  textMuted: '#9CA3AF',
  textDim: '#6B7280',
};

export const AGENTS = {
  director:       { name: 'Marketing Director',       color: '#F59E0B', short: 'Director' },
  content_writer: { name: 'Content Writer',            color: '#3B82F6', short: 'Writer' },
  seo_agent:      { name: 'SEO Specialist',            color: '#10B981', short: 'SEO' },
  social_media:   { name: 'Social Media Manager',      color: '#EC4899', short: 'Social' },
  email_marketing:{ name: 'Email Marketing Specialist', color: '#8B5CF6', short: 'Email' },
  outreach:       { name: 'Business Outreach Agent',   color: '#F97316', short: 'Outreach' },
};

export const STATUS = {
  pending:  { color: '#9CA3AF', bg: 'rgba(156,163,175,0.10)' },
  running:  { color: '#3B82F6', bg: 'rgba(59,130,246,0.15)' },
  review:   { color: '#F59E0B', bg: 'rgba(245,158,11,0.15)' },
  approved: { color: '#10B981', bg: 'rgba(16,185,129,0.15)' },
  rejected: { color: '#EF4444', bg: 'rgba(239,68,68,0.15)' },
  error:    { color: '#EF4444', bg: 'rgba(239,68,68,0.15)' },
};

export const CHANNELS = ['twitter', 'linkedin', 'instagram', 'email', 'blog', 'outreach'];
export const TIMEFRAMES = ['3 days', '1 week', '2 weeks', '1 month'];
